import { cva } from 'class-variance-authority';

export { default as CtaCard } from './Card.vue';

export interface CtaCardProps {
	imageSrc?: string;
	imageClass?: string;
	imageDesktopPosition?: 'left' | 'right';
	imageMobilePosition?: 'top' | 'bottom';
	imageSizes?: string;
	provider?: string;
}

export const ctaCardVariants = cva(
	'flex w-full flex-col-reverse gap-0 overflow-hidden rounded-lg lg:flex-row lg:gap-0',
	{
		variants: {
			imageDesktopPosition: {
				left: 'lg:flex-row-reverse',
				right: 'lg:flex-row'
			},
			imageMobilePosition: {
				top: 'flex-col',
				bottom: 'flex-col-reverse'
			}
		},
		defaultVariants: {
			imageDesktopPosition: 'right',
			imageMobilePosition: 'bottom'
		}
	}
);
